import "./vendor-contracts.scss";

import { observer } from "mobx-react";
import React, { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";

import { vendorsService } from "@/api";
import LoadingWrapper from "@/components/loading-wrapper";
import ListTitleSettings from "@/components/table/settings/ListTitleSettings";
import Table from "@/components/table/Table";
import { useMainStore } from "@/contexts/Store";
import { useLoadableData } from "@/hooks/useLoadableData";

import ContractRow from "../components/ContractRow";
import { contractsFields } from "../constants";
import { useSortable } from "../utils/useSortable";

function VendorContracts() {
  // Import MobX stores
  const mainStore = useMainStore();
  const { canManageAccounts } = mainStore.userPermissions;

  // Variables
  const { isCurrentWorkspaceActive } = mainStore.workspaces;

  // Hooks
  const history = useHistory();
  const { workspace_id: workspaceID, vendor_id } = useParams<{
    workspace_id: string;
    vendor_id: string;
  }>();
  const vendorID = Number(vendor_id);
  const vendorsContractsList = useLoadableData({
    request: () => vendorsService.listVendorContracts(vendorID, sortParams),
    onError: () => "Error. Please refresh to try again.",
  });
  const hasActiveVendor = !vendorsContractsList.data?.contracts?.find(
    (contract) => !contract.vendor_is_active,
  );
  const { sortByFieldName, sortDirection, sortParams, setSortBy } =
    useSortable();

  useEffect(() => {
    vendorsContractsList.refetch();
  }, [sortByFieldName, sortDirection]);

  // Functions
  function addNewContracts() {
    history.push(
      `/workspaces/${workspaceID}/modules/vendor-due-diligence/${vendor_id}/contracts/add-new-contracts`,
    );
  }

  return (
    <Table>
      <LoadingWrapper
        loading={!vendorsContractsList.data && vendorsContractsList.loading}
        errorText={vendorsContractsList.errorText}
        loadingLayout="table"
      >
        <div className="vendor-contracts table-list-wrap">
          <div className="list-title-table">
            <ul>
              <div className="list-column-wrap">
                <div className="list-title-table-wrap">
                  {contractsFields.map((field) => (
                    <ListTitleSettings
                      key={field.field_name}
                      title={field.display_name}
                      width={field.width}
                      sortable={field.sortable}
                      sortDirection={
                        field.sortable && sortByFieldName === field.field_name
                          ? sortDirection
                          : undefined
                      }
                      onClick={() =>
                        field.sortable && setSortBy(field.field_name)
                      }
                    />
                  ))}
                  <span className="stretch-cell" />
                </div>
              </div>
              <div className="vendor-contracts__table-title-indent" />
            </ul>
          </div>
          {isCurrentWorkspaceActive && hasActiveVendor && canManageAccounts && (
            <div className="vendor-contracts__add-new add-new-procedures">
              <button onClick={addNewContracts}>Add New Contract +</button>
            </div>
          )}
          {vendorsContractsList.data?.contracts?.map((contract) => {
            return <ContractRow key={contract.id} contract={contract} />;
          })}
        </div>
      </LoadingWrapper>
    </Table>
  );
}

export default observer(VendorContracts);
